module.exports = __webpack_public_path__ + "static/media/guardians.f2adefa5.png";